<template>
    <div>
        <!-- 调价 -->
        <vForm :model="formData" :label-width="90" class="margin-20 clearfix" inline ref="pricingform">
            <vCol span="24">
                <vFormItem :label="$t('global.common.channel', { defaultValue: '渠道' })">
                    <div>{{itemrow.accountFlag}}</div>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem label="Seller SKU">
                    <div>{{itemrow.sellerSku}}</div>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem :label="$t('global.common.currency', { defaultValue: '币种' })">
                    <div>{{itemrow.currencyCode}}</div>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem :label="$t('erp.channel.now_sale_price', { defaultValue: '当前销售价格' })">
                    <div>{{itemrow.price}}</div>
                    <div class="color-error">{{$t('erp.channel.attention_3', { defaultValue: '当前销售价格为接口上一次执行获取到的价格，可能与当时价格有偏差，请以具体页面查看到的实际价格为准' })}}</div>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem :label="$t('erp.channel.new_price', { defaultValue: '新价格' })" :rules="required" prop="price">
                    <vInput v-model="formData.price"></vInput>
                </vFormItem>
            </vCol>
            <!-- <vCol span="12">
                <vFormItem label="促销价格">
                    <vInput v-model="formData.salesPrice"></vInput>
                    <div class="color-error">若填写了促销价格，则必须填写促销价格对应的时间</div>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem label="促销时间区间">
                    <vDatepicker v-model="salesAt" format='yyyy-mm-dd ~ yyyy-mm-dd' style="width:100%"></vDatepicker>
                </vFormItem>
            </vCol> -->
            <!-- <vCol span="24">
                <vFormItem label="启动高级定价">
                    <Checkbox v-model="formData.businessPriceFlag"></Checkbox>
                </vFormItem>
            </vCol> -->
            <vCol span="12" v-if="formData.businessPriceFlag==true">
                <vFormItem label="Business Price">
                    <vInput v-model="formData.bussinessPrice" class="pull-left margin-right-5"></vInput>{{itemrow.currencyCode}}
                </vFormItem>
            </vCol>
            <vCol span="12" v-if="formData.businessPriceFlag==true">
                <vFormItem label="Business Price Type">
                    <RadioGroup v-model="formData.quantityPriceType" @on-change="changefixed">
                        <Radio label="percent"><span>{{$t('erp.channel.percent', { defaultValue: '百分比' })}}</span></Radio>
                        <Radio label="fixed"><span>{{$t('erp.channel.new_price', { defaultValue: '新价格' })}}</span></Radio>
                    </RadioGroup>
                    
                </vFormItem>
            </vCol>

            <vCol span="24" v-if="formData.businessPriceFlag==true">
                <vFormItem label="Quantity Discount">
                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right" v-model="formData.quantityLowerBound1"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput :readonly="formData.quantityPriceType=='fixed'" class="pull-right" v-model="present1"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{itemrow.currencyCode}})</span> <vInput :readonly="formData.quantityPriceType=='percent'" class="pull-right" v-model="quantityPrice1"></vInput></div>
                    </div>
                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right" v-model="formData.quantityLowerBound2"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput :readonly="formData.quantityPriceType=='fixed'" class="pull-right" v-model="present2"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{itemrow.currencyCode}})</span> <vInput :readonly="formData.quantityPriceType=='percent'" class="pull-right" v-model="quantityPrice2"></vInput></div>
                    </div>
                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right" v-model="formData.quantityLowerBound3"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput :readonly="formData.quantityPriceType=='fixed'" class="pull-right" v-model="present3"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{itemrow.currencyCode}})</span> <vInput :readonly="formData.quantityPriceType=='percent'" class="pull-right" v-model="quantityPrice3"></vInput></div>
                    </div>
                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right" v-model="formData.quantityLowerBound4"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput :readonly="formData.quantityPriceType=='fixed'" class="pull-right" v-model="present4"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{itemrow.currencyCode}})</span> <vInput :readonly="formData.quantityPriceType=='percent'" class="pull-right" v-model="quantityPrice4"></vInput></div>
                    </div>
                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right" v-model="formData.quantityLowerBound5"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput :readonly="formData.quantityPriceType=='fixed'" class="pull-right" v-model="present5"></vInput></div>
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{itemrow.currencyCode}})</span> <vInput :readonly="formData.quantityPriceType=='percent'" class="pull-right" v-model="quantityPrice5"></vInput></div>
                    </div>
                </vFormItem>
            </vCol>
        </vForm>
        <compWrapper :title="$t('global.common.operation_history', { defaultValue: '操作历史' })" theme="gray">
            <TableList class="margin-layout" v-bind="getTableProps"></TableList>
        </compWrapper>
        <div class="text-right">
            <vButton class="margin-right-10" theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
            <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
        </div>
    </div>
</template>

<script>
import {
	HttpChangePrice,
    HttpSysOpLog
} from '@/service/products/channel'
import TableList from "@components/templates/tablelist";
export default {
    props:['itemrow'],
    components:{
        TableList
    },
    data(){
        return {
            formData:{
                bussinessPrice:0,
                productChannelId:0,
                businessPriceFlag:false,
                quantityPriceType:'percent',
            },
            showHighprice:false,
            present1:0,
            present2:0,
            present3:0,
            present4:0,
            present5:0,
            salesAt:'',
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],
        }
    },
    computed:{
        "quantityPrice1":{
            get: function () {
                let price;
                if(this.formData.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.bussinessPrice * (1-(this.present1/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        "quantityPrice2":{
            get: function () {
                let price;
                if(this.formData.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.bussinessPrice * (1-(this.present2/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        "quantityPrice3":{
            get: function () {
                let price;
                if(this.formData.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.bussinessPrice * (1-(this.present3/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        "quantityPrice4":{
            get: function () {
                let price;
                if(this.formData.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.bussinessPrice * (1-(this.present4/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        "quantityPrice5":{
            get: function () {
                let price;
                if(this.formData.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.bussinessPrice * (1-(this.present5/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        getTableProps () {
            return {
                columns: [
                    {
                        title: this.$t("global.common.operator", { defaultValue: "操作人" }),
                        key: "opUserName"
                    },
                    {
                        title: this.$t("global.common.operate_time", { defaultValue: "操作时间" }),
                        key: "opAt"
                    },
                    {
                        title: this.$t("erp.channel.operation_content", { defaultValue: "操作内容" }),
                        key: "opRemark",
                        render: (h, { row }) => {
                            return (
                                <div>
                                    <div>{this.$t("global.common.operate_type", { defaultValue: "操作类型" })}:{row.opAction}</div>
                                    <div>{this.$t("global.common.operate_note", { defaultValue: "操作原因" })}:{row.opRemark}</div>
                                </div>
                            );
                        }
                    }
                ],
				initFormData: {
                    search: {
                        EQ_opDataId: this.itemrow.id,
                        EQ_opModel: "Product_Channel",
                        EQ_opAction: "changePrice"
                    },
				},
				ajaxRequest: HttpSysOpLog,
				startUp: true
            };
        }

    },
    methods:{
        async submit(){
            const valid = await this.$refs['pricingform'].validate();
            if (!valid) return;
            
            // 时间区间的拿取
            let array = this.salesAt.split('~');
            this.formData.startDate = array[0];
            this.formData.endDate = array[1];
            if(this.formData.businessPriceFlag == true){
                this.formData.quantityPrice1 = this.quantityPrice1
                this.formData.quantityPrice2 = this.quantityPrice2
                this.formData.quantityPrice3 = this.quantityPrice3
                this.formData.quantityPrice4 = this.quantityPrice4
                this.formData.quantityPrice5 = this.quantityPrice5

                this.formData.precent1 = this.present1
                this.formData.precent2 = this.present2
                this.formData.precent3 = this.present3
                this.formData.precent4 = this.present4
                this.formData.precent5 = this.present5
            }
            this.formData.productChannelId = this.itemrow.id
            HttpChangePrice({
                ...this.formData
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.cancel()
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        changefixed(){
            if(this.formData.quantityPriceType == 'fixed'){
                this.present1 = 0;
                this.present2 = 0;
                this.present3 = 0;
                this.present4 = 0;
                this.present5 = 0;
            }else{
                this.quantityPrice1 = 0;
                this.quantityPrice2 = 0;
                this.quantityPrice3 = 0;
                this.quantityPrice4 = 0;
                this.quantityPrice5 = 0;
            }
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>